import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class DominioServico extends Servico {
  constructor() {
    super('dominio')
  }

  recuperarValoresDominio(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/valores`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default DominioServico
